<app-component-subnav></app-component-subnav>

<main *ngIf="technologies">
  <h2>PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Technische Verfahren</h2>
  <clr-datagrid *ngIf="technologies.length > 0" [clrDgLoading]="loading">
    <clr-dg-column [clrDgField]="'technical_drawing'">Zeichnungsnummer</clr-dg-column>
    <clr-dg-column [clrDgField]="'name'">Bezeichnung</clr-dg-column>
    <clr-dg-column [clrDgField]="'description'">Kurzbeschreibung</clr-dg-column>
    <clr-dg-column [clrDgField]="'number_of_pieces_in_stock'">Lagerbestand (Warehouse)</clr-dg-column>
    <clr-dg-placeholder>We couldn't find any Technology!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let assembly of technologies" [routerLink]="['/component/details', assembly.technical_drawing]">
      <clr-dg-cell>{{ assembly.technical_drawing }}</clr-dg-cell>
      <clr-dg-cell><b>{{ assembly.name }}</b></clr-dg-cell>
      <clr-dg-cell>{{ assembly.description }}</clr-dg-cell>
      <clr-dg-cell> --- </clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
      <clr-dg-pagination #pagination [clrDgPageSize]="50">
        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Verfahren pro Seite</clr-dg-page-size>
        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
        von {{ technologies.length }} Verfahren
      </clr-dg-pagination>
    </clr-dg-footer>
  </clr-datagrid>
</main>
